/*
 * The publish modal english translation
 */
export const PUBLISH_MODAL_EN = {
  publishModalTitle: 'Publish',
  download: 'Download',
  publish: 'Publish',
  sendAsEmail: 'Send as E-Mail',
  downloadAsFormat: 'Download as {format}',
  publishToFormat: 'Publish to {format}',
  documentDownloadedSuccessfully: '{format} downloaded successfully',
  failedToDownloadDocument: 'Failed to download {format} document',
  failedToGenerateDocument: 'Failed to generate {format} document',
  emailSentSuccessfully: 'Email sent successfully',
  emailSendFailed: 'Failed to send email'
}

/*
 * The publish modal german translation
 */
export const PUBLISH_MODAL_DE = {
  publishModalTitle: 'Veröffentlichen',
  download: 'Herunterladen',
  publish: 'Veröffentlichen',
  sendAsEmail: 'Als E-Mail senden',
  downloadAsFormat: 'Als {format} herunterladen',
  publishToFormat: 'In {format} veröffentlichen',
  documentDownloadedSuccessfully: '{format} erfolgreich heruntergeladen',
  failedToDownloadDocument: '{format}-Dokument konnte nicht heruntergeladen werden',
  failedToGenerateDocument: '{format}-Dokument konnte nicht erstellt werden',
  emailSentSuccessfully: 'E-Mail erfolgreich gesendet',
  emailSendFailed: 'E-Mail konnte nicht gesendet werden'
}
